import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Bar } from 'react-chartjs-2';
import { makeStyles, useTheme } from '@material-ui/styles';
import { colors } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative'
  }
}));

function TeamPerformanceChart({ summaries, className, ...rest }) {
  const classes = useStyles();
  const theme = useTheme();

  const labels = summaries.map((employee) => employee.name);
  const invalid = summaries.map((history) => history.invalid);
  const negative = summaries.map((history) => history.negative);
  const positive = summaries.map((history) => history.positive);

  const data = {
    datasets: [
      {
        label: 'Invalid',
        backgroundColor: colors.red[400],
        data: invalid,
        barThickness: 12,
        maxBarThickness: 10,
        barPercentage: 0.5,
        categoryPercentage: 0.5
      },
      {
        label: 'Nagative',
        backgroundColor: colors.orange[400],
        data: negative,
        barThickness: 12,
        maxBarThickness: 10,
        barPercentage: 0.5,
        categoryPercentage: 0.5
      },
      {
        label: 'Positive',
        backgroundColor: colors.green[400],
        data: positive,
        barThickness: 12,
        maxBarThickness: 10,
        barPercentage: 0.5,
        categoryPercentage: 0.5
      }
    ],
    labels
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    cornerRadius: 20,
    legend: {
      display: false
    },
    layout: {
      padding: 0
    },
    scales: {
      xAxes: [
        {
          gridLines: {
            display: false,
            drawBorder: false
          },
          ticks: {
            padding: 20,
            fontColor: theme.palette.text.secondary
          }
        }
      ],
      yAxes: [
        {
          gridLines: {
            borderDash: [2],
            borderDashOffset: [2],
            color: theme.palette.divider,
            drawBorder: false,
            zeroLineBorderDash: [2],
            zeroLineBorderDashOffset: [2],
            zeroLineColor: theme.palette.divider
          },
          ticks: {
            padding: 20,
            fontColor: theme.palette.text.secondary,
            beginAtZero: true,
            min: 0,
            maxTicksLimit: 5,
            callback: (value) => (value > 0 ? `${value}` : value)
          }
        }
      ]
    },
    tooltips: {
      enabled: true,
      mode: 'index',
      intersect: false,
      caretSize: 10,
      yPadding: 20,
      xPadding: 20,
      borderWidth: 1,
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.common.white,
      titleFontColor: theme.palette.text.primary,
      bodyFontColor: theme.palette.text.secondary,
      footerFontColor: theme.palette.text.secondary,
      callbacks: {
        title: () => {
        },
        // eslint-disable-next-line consistent-return
        label: (tooltipItem) => {
          if (tooltipItem.datasetIndex === 0) {
            return `Invalid : ${tooltipItem.yLabel}`;
          }

          if (tooltipItem.datasetIndex === 1) {
            return `Negative : ${tooltipItem.yLabel}`;
          }

          if (tooltipItem.datasetIndex === 2) {
            return `Positive : ${tooltipItem.yLabel}`;
          }
        }
      }
    }
  };

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Bar
        data={data}
        options={options}
      />
    </div>
  );
}

TeamPerformanceChart.propTypes = {
  className: PropTypes.string,
  summaries: PropTypes.array.isRequired
};

export default TeamPerformanceChart;
